var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eAWlcsdmGxf1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.428571 0 0 1.428571-4.28571-4.28571)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    ry: 7,
    transform: "matrix(0-1 1 0 3 17)",
    fill: "#dc9b3b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70972,6.06318c.88431-.27447,1.89069-.06099,2.59208.64038.7623.76238.9453,1.92111.5184,2.86638l2.9579,2.92756c.3659.3659.3659.9453,0,1.2807-.3354.3659-.9148.3659-1.2808,0L9.53939,10.8203c-.9148.4269-2.07364.244-2.83597-.5184-.70138-.70138-.9148-1.7076-.64039-2.59204.061-.18298.27448-.21347.39641-.09149L7.9841,9.14303c.061.06099.21348.06099.30492,0l.85386-.85386c.061-.09149.061-.24398,0-.30492L7.61822,6.45959c-.12199-.12199-.09148-.33541.0915-.39641Z",
    transform: "matrix(1.428571 0 0 1.428571-4.285665-4.285713)",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEdit);
export default __webpack_public_path__ + "static/media/new-edit.bc5663f90805489e69f233e81c5dbd2f.svg";
export { ForwardRef as ReactComponent };